<section class="main-layout s-h-full">
  <section class="title">
    <p class="text-title">กรุณากรอก OTP</p>
    <!-- <p class="text-sub">Ref. {{refOtpSignal().ref_no | json}}</p> -->

    <p class="text-sub">Ref. {{ ref_no }}</p>
  </section>
  <section class="layout-ecoupon">
    <form (submit)="onClick()">
      <fieldset class="ecoupon-form">
        <div class="flex">
          <mat-form-field class="bg-white">
            <input id="otp" name="otp" type="text" maxlength="6" matInput placeholder="OTP" [(ngModel)]="otpForm().no" />
            <!-- <input matInput [(ngModel)]="otpForm().ref_no" placeholder="OTP" /> -->
          </mat-form-field>
          @if (timeRemaining$ | async; as timeRemaining) {
            <p class="layout-countdown">
              OTP จะหมดอายุใน : {{ timeRemaining | date : 'mm:ss' }}
            </p>
          } @else {
          }

          <span class="text-warning">{{ errMessage }}</span>
          <div>
            <button mat-button type="button" (click)="onClickResend()">ส่ง OTP อีกครั้ง</button>
          </div>
          <!-- } -->
        </div>

        <button mat-flat-button style="transform: skewX(-10deg)" type="submit">ตกลง</button>
      </fieldset>
    </form>
  </section>
</section>
